import React, { useState } from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import CardImg from "../../../../components/CardImg";

/**
 * Unique Teenpatti card overlay — reference markup (casino/teenunique):
 *   .casino-video-cards[.hide-cards] > .casino-cards-shuffle (toggle) + .casino-video-cards-container
 *   > 6 × div > span > img
 * The reference hides the strip while the first card is still the "1" placeholder, and the
 * shuffle handle toggles it once cards are out. Styled by index.css (.casino-table.teenpatti20).
 * cardTokens: array or comma-separated string of the round's 6 card tokens.
 */
export default function TeenUniqueCardsOverlay({ cardTokens = [] }) {
  const [showCards, setShowCards] = useState(true);
  const tokens = Array.isArray(cardTokens)
    ? cardTokens
    : String(cardTokens ?? "")
        .split(",")
        .map((c) => c.trim());
  if (!tokens.length || (tokens.length === 1 && !tokens[0])) return null;
  const cards = Array.from({ length: 6 }, (_, i) => tokens[i] || "1");
  const hidden = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  const toggleCards = () => {
    if (cards[0] !== "1") setShowCards((v) => !v);
  };

  return (
    <div className={`casino-video-cards${hidden ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={toggleCards}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        {cards.map((token, i) => (
          <React.Fragment key={i}>
            {i > 0 && " "}
            <div>
              <span>
                <CardImg src={getCardImage(token)} />
              </span>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
